import React from 'react';
import { useTranslation } from 'react-i18next';

function ListingCardImage() {
  const { t } = useTranslation('common');

  return (
    <div className="listing-card card">
      <div className="image-detail">
        <figure>
          <div className="img-preview-inside-table">
            <span className="big-image">
              <img src="/assets/images/no-image.png" alt="noImage" />
            </span>
            <img src="/assets/images/no-image.png" alt="noImg" />
          </div>
        </figure>
      </div>
      <div className="card-header">
        <div>
          <ul className="card-header-icon">
            <li>
              <div className="cus-chk-block">
                <input name="check_0" id="check_0" type="checkbox" />
                <label htmlFor="check_0" className="cus-chklabel" />
              </div>
            </li>
            <li>
              <a href={false} title={t('LISTING_CARD_IMAGE.EDIT')}>
                <i className="icon-edit" />
              </a>
            </li>
            <li>
              <a href={false} title={t('LISTING_CARD_IMAGE.DELETE')}>
                <i className="icon-delete" />
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="card-body">
        <h4 className="title link-title">
          {t('LISTING_CARD_IMAGE.TEST_LIB')}
          <a href={false}>
            {' '}
            <i className="icon-detail_page pl-1" />
          </a>
        </h4>
        <ul className="card-ul">
          <li>
            <strong>{t('LISTING_CARD_IMAGE.PRODUCT_ASSOCIATION')}: </strong>
            {t('LISTING_CARD_IMAGE.ACCESSORIES_ARTWORK')}
          </li>
          <li>
            <strong>{t('LISTING_CARD_IMAGE.ADDITIONAL_INFO')}: </strong>
            {t('LISTING_CARD_IMAGE.TEST')}
          </li>
          <li>
            <strong>{t('LISTING_CARD_IMAGE.CREATED_BY_DATE_TIME')} : </strong>
            {t('LISTING_CARD_IMAGE.MATANG_RAMDEVPUTRAM')}
            <span> 12:11 </span>
          </li>
          <li>
            <strong>{t('LISTING_CARD_IMAGE.MODIFIED_BY_DATE_TIME')} : </strong>
            {t('LISTING_CARD_IMAGE.MATANG_RAMDEVPUTRAM')}
            <span>12:11 </span>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default ListingCardImage;
